export const IMMIGRATE_CATEGORY_EDIT_SUBMIT_REQUEST = 'immigrate-category/edit-submit-request'
export const IMMIGRATE_CATEGORY_EDIT_SUBMIT_SUCCESS = 'immigrate-category/edit-submit-success'
export const IMMIGRATE_CATEGORY_EDIT_SUBMIT_FAILED = 'immigrate-category/edit-submit-failed'
